import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserListsDetailsComponent } from './users/user-lists-details.component';

@NgModule({
  imports: [RouterModule.forChild([{ path: ':listId/users', component: UserListsDetailsComponent }])],
  exports: [RouterModule],
})
export class ListsRoutingModule {}
